import React from 'react';
import PriceHistoryCell from './Pricehistorycell';
import { computePriceChange30Days } from './gpuUtils';

// Map Amazon condition numbers to text labels. Adjust as needed.
const conditionMapping = {
    1: 'New',
    2: 'Used - Like New',
    3: 'Used - Very Good',
    4: 'Used - Good',
    5: 'Used - Acceptable'
};

const GPUItem = ({ gpu }) => {
    // Compute the 30-day price change.
    const priceChange = computePriceChange30Days(gpu.price_history);
    let changeText = 'N/A';
    let changeClass = '';
    if (priceChange !== null) {
        if (priceChange > 0) {
            changeText = `+${priceChange.toFixed(2)}%`;
            changeClass = 'text-green-500';
        } else if (priceChange < 0) {
            changeText = `${priceChange.toFixed(2)}%`;
            changeClass = 'text-red-500';
        } else {
            changeText = `${priceChange.toFixed(2)}%`;
        }
    }

    // Extract sparkline data from the GPU's price history.
    const sparklineData =
        gpu.price_history && gpu.price_history.Amazon
            ? gpu.price_history.Amazon.filter(record => record.price !== null && record.date)
            : [];

    // Build the "Other sellers" cell combining best used price and condition.
    let otherSellersDisplay = 'N/A';
    if (
        gpu.best_used_price !== undefined &&
        gpu.best_used_price !== null &&
        gpu.best_used_condition !== undefined &&
        gpu.best_used_condition !== null
    ) {
        const priceStr = `$${Number(gpu.best_used_price).toFixed(2)}`;
        const conditionStr = conditionMapping[gpu.best_used_condition] || gpu.best_used_condition;
        otherSellersDisplay = `${priceStr} (${conditionStr})`;
    } else if (gpu.best_used_price !== undefined && gpu.best_used_price !== null) {
        otherSellersDisplay = `$${Number(gpu.best_used_price).toFixed(2)}`;
    }

    return (
        <tr className="hover:bg-gray-100">
            <td className="border border-gray-300 px-2 py-2">
                <a
                    href={gpu.product_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-500 hover:underline"
                >
                    {gpu.title}
                </a>
            </td>
            <td className="border border-gray-300 px-2 py-2 whitespace-nowrap">
                {gpu.cardseries}
            </td>
            <td className="border border-gray-300 px-2 py-2">{gpu.manufacturer}</td>
            <td className="border border-gray-300 px-2 py-2">
                {gpu.current_price !== undefined && gpu.current_price !== null
                    ? `$${Number(gpu.current_price).toFixed(2)}`
                    : 'N/A'}
            </td>
            <td className="border border-gray-300 px-2 py-2">
                {gpu.base_stock !== undefined && gpu.base_stock !== null
                    ? gpu.base_stock
                    : 'N/A'}
            </td>
            <td className="border border-gray-300 px-2 py-2">
                {sparklineData.length > 0 ? (
                    <PriceHistoryCell sparklineData={sparklineData} />
                ) : (
                    'N/A'
                )}
            </td>
            <td className="border border-gray-300 px-2 py-2">
                <span className={changeClass}>{changeText}</span>
            </td>
            <td className="border border-gray-300 px-2 py-2">
                {otherSellersDisplay}
            </td>

        </tr>
    );
};

export default GPUItem;
